import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { NotificationService } from 'src/app/shared/Notification.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';

import { ThanhVien } from 'src/app/shared/ThanhVien.model';
import { ThanhVienService } from 'src/app/shared/ThanhVien.service';
import { DanhMucThanhVien } from 'src/app/shared/DanhMucThanhVien.model';
import { DanhMucThanhVienService } from 'src/app/shared/DanhMucThanhVien.service';
import { ThanhVienDetailComponent } from '../thanh-vien-detail/thanh-vien-detail.component';
import { CompanyInfoService } from 'src/app/shared/CompanyInfo.service';

@Component({
  selector: 'app-active-thanh-vien',
  templateUrl: './active-thanh-vien.component.html',
  styleUrls: ['./active-thanh-vien.component.css']
})
export class ActiveThanhVienComponent implements OnInit {

  @ViewChild('ThanhVienSort') ThanhVienSort: MatSort;
  @ViewChild('ThanhVienPaginator') ThanhVienPaginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    public NotificationService: NotificationService,

    public ThanhVienService: ThanhVienService,
    public DanhMucThanhVienService: DanhMucThanhVienService,
    public CompanyInfoService: CompanyInfoService,
  ) { }

  ngOnInit(): void {
    this.ThanhVienService.BaseParameter.SearchString = "";
    this.ThanhVienService.GetLogin();
    this.DanhMucThanhVienSearch();
    this.CompanyInfoSearch();
  }
  countLoading = 0;
  StopLoading(){
    this.countLoading--;
    if(this.countLoading == 0){
      this.ThanhVienService.IsShowLoading = false;
    }
  }
  StartLoading(){
    if(this.countLoading == 0){
      this.ThanhVienService.IsShowLoading = true;
    }
    this.countLoading++;
  }

  DanhMucThanhVienSearch() {
    this.StartLoading();
    this.DanhMucThanhVienService.GetAllToListAsync().subscribe(
      res => {
        this.DanhMucThanhVienService.List = (res as any[]).sort((a, b) => (a.SortOrder > b.SortOrder ? 1 : -1));
        this.DanhMucThanhVienService.ListFilter = this.DanhMucThanhVienService.List;
        this.StopLoading();
      },
      err => {
        this.StopLoading();
      }
    );
  }
  CompanyInfoSearch() {
    this.StartLoading();
    this.CompanyInfoService.GetAllToListAsync().subscribe(
      res => {
        this.CompanyInfoService.List = (res as any[]).sort((a, b) => (a.SortOrder > b.SortOrder ? 1 : -1));
        this.CompanyInfoService.ListFilter = this.CompanyInfoService.List;
        this.ThanhVienSearch();
        this.StopLoading();
      },
      err => {
        this.StopLoading();
      }
    );
  }
  FindNameByID(ID:number,list:any[]):string{
    if(ID == 0 || ID == null || ID == undefined || list.length == 0) return '';
    const result = list.find(l=>l.ID == ID);
    if(result) return result.Name;
    return '';
  }

  async ThanhVienSearch(): Promise<void>{
    this.StartLoading();
    this.ThanhVienService.BaseParameter.StateAgencyID = this.ThanhVienService.FormDataLogin.StateAgencyID;
    this.ThanhVienService.GetByStateAgencyID_SearchStringToListAsync().subscribe(
      async res => {
        this.ThanhVienService.List = (res as ThanhVien[]).sort((a, b) => (a.SortOrder > b.SortOrder ? 1 : -1));
        // await this.CompanyInfoService.GetAllToListAsyncUpdate();
        this.ThanhVienService.List = this.ThanhVienService.List.filter(t=> t.Active != true);
        this.ThanhVienService.List.forEach(element => {
          element.CompanyInfoName = this.FindNameByID(element.CompanyInfoID,this.CompanyInfoService.List)
        });
        // this.ThanhVienService.List.filter(t=> t.CompanyInfoName = this.FindNameByID(t.CompanyInfoID,this.CompanyInfoService.List))
        // DistrictDataID
        this.ThanhVienService.DataSource = new MatTableDataSource(this.ThanhVienService.List);
        this.ThanhVienService.DataSource.sort = this.ThanhVienSort;
        this.ThanhVienService.DataSource.paginator = this.ThanhVienPaginator;
        this.StopLoading();
      },
      err => {
        this.StopLoading();
      }
    );
  }
  ThanhVienSave(element: ThanhVien) {
    element.ParentID = this.ThanhVienService.BaseParameter.ParentID;
    this.ThanhVienService.FormData = element;
    this.NotificationService.warn(this.ThanhVienService.ComponentSaveAll(this.ThanhVienSort, this.ThanhVienPaginator));
  }
  ThanhVienDelete(element: ThanhVien) {
    this.ThanhVienService.BaseParameter.ID = element.ID;
    this.NotificationService.warn(this.ThanhVienService.ComponentDeleteAll(this.ThanhVienSort, this.ThanhVienPaginator));
  }
  ThanhVienAdd(ID: number) {
    this.ThanhVienService.BaseParameter.ID = ID;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = environment.DialogConfigWidth;
    dialogConfig.data = { ID: ID };
    const dialog = this.dialog.open(ThanhVienDetailComponent, dialogConfig);
    dialog.afterClosed().subscribe(() => {
      this.ThanhVienSearch();
    });
  }
}
